/* eslint-disable no-param-reassign */
/* eslint-disable no-throw-literal */
/* eslint-disable no-lonely-if */
/* eslint-disable no-undef */
/* eslint-disable max-classes-per-file */
/* eslint-disable prefer-template */
/* eslint-disable arrow-body-style */
(() => {
  class Cart extends HTMLElement {
    connectedCallback() {
      this.cartDrawer = this.parentElement;
      this.cartOpener = document.querySelector(".js-cart-drawer-opener");
      this.loadingSpinner = this.querySelector(".js-cart-drawer__overlay");

      this.handleCartAnimation();
      this.addEventListener("deleteLineItem", (e) => {
        this.updateQuantity(e.detail.state, false);
      });

      this.addEventListener("changeQuantity", (e) => {
        this.updateQuantity(e.detail.state, false);
      });
    }

    async handleError(e) {
      if (e) {
        showErrorBox(e.message, this);
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add("hidden");
        }
        return;
      }
      showErrorBox(this.dataset.defaulterror, this);
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.add("hidden");
      }
    }

    reattachCloser() {
      const cartOpener = document.querySelectorAll(".js-cart-drawer-opener");

      const cartCloser = this.querySelectorAll(".js-cart-drawer-closer");

      cartOpener.forEach((opener) => {
        opener.addEventListener("click", this.openHandler.bind(this));
      });

      cartCloser.forEach((closer) => {
        closer.addEventListener("click", this.closeHandler.bind(this));
      });
    }

    handleCartAnimation() {
      const cartOpener = document.querySelectorAll(".js-cart-drawer-opener");

      const cartCloser = this.querySelectorAll(".js-cart-drawer-closer");

      this.closeHandler = () => {
        requestAnimationFrame(() => {
          this.querySelector(".cart-drawer").style.setProperty("--visiblity", `hidden`);
          this.querySelector(".cart-drawer__container").style.setProperty("--translate", `100%`);
        });
        document.querySelector("body").classList.remove("overflow-hidden");
      };
      this.openHandler = () => {
        requestAnimationFrame(() => {
          this.querySelector(".cart-drawer").style.setProperty("--visiblity", `visible`);
          this.querySelector(".cart-drawer__container").style.setProperty("--translate", `0%`);
        });
        document.querySelector("body").classList.add("overflow-hidden");
      };
      cartOpener.forEach((opener) => {
        opener.addEventListener("click", this.openHandler.bind(this));
      });

      cartCloser.forEach((closer) => {
        closer.addEventListener("click", this.closeHandler.bind(this));
      });
    }

    async addToCart(formData, quantityWarning = null, maxQty = null) {
      try {
        const response = await fetch(`/cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const responseJson = await response.json();
        if (!response.ok) {
          throw {
            message: responseJson.message,
            status: responseJson.status,
          };
        }

        await this.updateCart();

        // Show warning if quantity was above max
        if (quantityWarning && window.quickOrderListStrings?.max_error && maxQty) {
          const errorMessage = window.quickOrderListStrings.max_error.replace("[max]", maxQty);
          showErrorBox(errorMessage, this);
        }

        return true;
      } catch (error) {
        this.handleError(error);
        return false;
      }
    }

    async updateCart(openDrawer = true) {
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.remove("hidden");
      }
      try {
        const response = await fetch(`${routes.cart_url}?sections=cart-drawer,header`);
        const responseText = await response.text();
        const json = JSON.parse(responseText);
        const htmlHeader = new DOMParser().parseFromString(json.header, "text/html");
        const currentCartLink = document.querySelector("header.header .cart-icon-link");
        const newCartLink = htmlHeader.querySelector("header.header .cart-icon-link");
        if (currentCartLink && newCartLink) {
          currentCartLink.innerHTML = newCartLink.innerHTML;
          currentCartLink.classList.toggle(
            "cart-icon-link--has-items",
            newCartLink.classList.contains("cart-icon-link--has-items"),
          );
        }
        const htmlDrawer = new DOMParser().parseFromString(json["cart-drawer"], "text/html");
        const selectors = [".cart-drawer__container"];
        selectors.forEach((selector) => {
          const targetElement = this.querySelector(selector);
          const sourceElement = htmlDrawer.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.innerHTML = sourceElement.innerHTML;
          }
        });
        this.reattachCloser();
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add("hidden");
        }
        const cartItemHolder = this.querySelector(".cart-drawer__products-holder");
        if (cartItemHolder) {
          let total = 0;
          cartItemHolder.querySelectorAll(".js-qty-input").forEach((input) => {
            total += parseInt(input.value, 10);
          });
          document.querySelectorAll(".js-header-bar__show-amount").forEach((elem) => {
            elem.innerHTML = total;
          });
        }

        const privatePriceHolder = document.querySelector(".js-cart-icon-link__total--private");
        const corporatePriceHolder = document.querySelector(".js-cart-icon-link__total--corporate");

        if (privatePriceHolder) {
          privatePriceHolder.textContent = this.querySelector(".js-total-cart-price.js-private-price")?.textContent;
        }

        if (corporatePriceHolder) {
          corporatePriceHolder.textContent = this.querySelector(".js-total-cart-price.js-corporate-price")?.textContent;
        }

        if (openDrawer) {
          this.cartOpener.click();
        }
      } catch (error) {
        showErrorBox(this.dataset.defaulterror, this);
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add("hidden");
        }
      }
    }

    async updateQuantity(state, openDrawer = false) {
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.remove("hidden");
      }

      // Store error state before updating
      const hasError = !state.hasCorrectQuantity;
      const errorMessage = state.message;

      if (hasError) {
        showErrorBox(errorMessage, this); // Display the error box
      }

      const key = state.id;
      const qty = state.quantity;

      const body = JSON.stringify({
        id: key,
        quantity: parseInt(qty, 10),
      });

      try {
        const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });
        const responseJson = await response.json();
        if (!response.ok) {
          throw {
            message: responseJson.errors,
          };
        }
        await this.updateCart(openDrawer);

        // Restore error message after cart reload if there was an error
        if (hasError && errorMessage) {
          showErrorBox(errorMessage, this);
        }

        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add("hidden");
        }
      } catch (error) {
        this.handleError(error);
      }
    }
  }

  if (!customElements.get("cart-drawer")) {
    customElements.define("cart-drawer", Cart);
  }
})();
